import React from 'react';
import { motion } from 'framer-motion';
interface PageTransitionProps {
  children: React.ReactNode;
  direction?: 'forward' | 'back' | 'none';
}
export function PageTransition({
  children,
  direction = 'forward'
}: PageTransitionProps) {
  const variants = {
    initial: {
      opacity: 0,
      x: direction === 'forward' ? 20 : direction === 'back' ? -20 : 0
    },
    animate: {
      opacity: 1,
      x: 0
    },
    exit: {
      opacity: 0,
      x: direction === 'forward' ? -20 : direction === 'back' ? 20 : 0
    }
  };
  return <motion.div variants={variants} initial="initial" animate="animate" exit="exit" transition={{
    type: 'spring',
    stiffness: 300,
    damping: 30,
    opacity: {
      duration: 0.2
    }
  }} data-id="element-376">
      {children}
    </motion.div>;
}